import { useEffect, useState } from "react";
import clsx from "clsx";
import { useT } from "@app/contexts/preferences.context";
import { btn, btnPrimary } from "./index";

interface CheckoutBarProps {
  /** id của khung tóm tắt (Thông tin tạo máy / thuê): khung đó đang hiện trên màn hình thì ẩn thanh */
  targetId: string;
  /** Đã chọn gói / cấu hình */
  active: boolean;
  /** "Gaming Pro 1 · 3 giờ" */
  name: string;
  /** "75.000 VND" */
  total: string;
}

/**
 * Thanh "Tiếp tục" cố định ở đáy màn hình (<= 1100px) như bản thiết kế: khi đã chọn cấu hình mà
 * khung tóm tắt nằm ngoài màn hình, bấm Tiếp tục để cuộn tới khung đó.
 */
function CheckoutBar({ targetId, active, name, total }: CheckoutBarProps) {
  const t = useT();
  const [targetVisible, setTargetVisible] = useState(false);

  useEffect(() => {
    const el = document.getElementById(targetId);

    if (!el || typeof IntersectionObserver === "undefined") return;

    const observer = new IntersectionObserver((entries) => setTargetVisible(entries[0].isIntersecting), {
      threshold: 0.15,
    });

    observer.observe(el);

    return () => observer.disconnect();
  }, [targetId]);

  const show = active && !targetVisible;

  return (
    <>
      {/* chừa chỗ để thanh không che nội dung cuối trang */}
      {active && <div aria-hidden className="hidden h-20 max-[1100px]:block" />}
      <div
        className={clsx(
          "fixed inset-x-0 bottom-0 z-40 hidden items-center gap-3 border-t border-line bg-surface px-4 pb-[calc(10px+env(safe-area-inset-bottom,0px))] pt-2.5 shadow-[0_-6px_20px_rgba(0,0,0,.08)]",
          show && "max-[1100px]:flex"
        )}
      >
        <div className="min-w-0 flex-1 leading-[1.3]">
          <small className="block truncate text-xs text-muted">{name}</small>
          <strong className="text-base tabular-nums text-brand">{total}</strong>
        </div>
        <button
          type="button"
          className={clsx(btn, btnPrimary)}
          onClick={() => document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth", block: "start" })}
        >
          {t("Tiếp tục")}
        </button>
      </div>
    </>
  );
}

export default CheckoutBar;
